import Node from '@/glxp/abstract/node'
import Point from '@/glxp/entities/point'
import {mat4} from 'gl-matrix'

// Todo Hierachy skin 


class Skin {
    constructor (mesh, skinData, rootnodeName){
        this.mesh = mesh
        this.bonesNumb = skinData.joints.length

        this.skinData = skinData
        this.rootnodeName = rootnodeName

        this.debug = true
        this.debugPoints = []

        this.allocateData()
        this.initNodes()
        this.getBindPose()
        this.computeAttributeData()

    }

    initNodes(){

        for (let i = 0; i < this.skinData.joints.length; i++) {
            const joint = this.skinData.joints[i];            
            for (let j = 0; j < this.mesh.nodeTree.length; j++) {
                const element = this.mesh.nodeTree[j];
                if (element.sid !== undefined && element.sid == joint.sid) {
                    joint.node = element
                    element.joint = joint
                    this.bonesNode.push(element)
                }
            }
        }

        let rootNode
        for (let i = 0; i < this.bonesNode.length; i++) {
            if (this.bonesNode[i].name == this.rootnodeName) {
                rootNode = this.bonesNode[i]
            }
        }
        this.mesh.node.addChildNode(rootNode)
        this.rootNode = rootNode

        for (let i = 0; i < this.bonesNode.length; i++) {
            this.bonesNode[i].needUpdate = true
            this.bonesNode[i].getMatrix()
        }
        
        // --------        
        for (let i = 0; i < this.bonesNode.length; i++) {
            let p = new Point(this.mesh.scene)
            p.node = this.bonesNode[i]
            this.debugPoints.push(p)
        }

    }

    allocateData(){
        this.boneArray          = new Float32Array(this.bonesNumb * 16)
        this.boneMatrices       = []  // the uniform data
        this.bindPose           = []  // the bind matrix        
        this.bindPoseInv        = []  
        this.bonesNode          = []

        for (var i = 0; i < this.bonesNumb; ++i) {
            this.boneMatrices.push(new Float32Array(this.boneArray.buffer, i * 4 * 16, 16))
            this.bindPose.push(mat4.create())  // just allocate storage
            this.bindPoseInv.push(mat4.create())     // just allocate storage
        }
    }

    computeAttributeData(){
        let stacks = this.skinData.attribStackNum
        this.attribData = {}

        for (let i = 0; i < stacks; i++) {
            let weightData = this.skinData["weight_" + i]
            let ndxData = this.skinData["ndx_" + i]
            let refactorWeight = []
            let refactorNdx = []
            for (let j = 0; j < this.mesh.geom.vertexIndex.length; j++) {
                const weightIdx = this.mesh.geom.vertexIndex[j];
                refactorWeight.push(weightData[weightIdx * 4 + 0])
                refactorWeight.push(weightData[weightIdx * 4 + 1])
                refactorWeight.push(weightData[weightIdx * 4 + 2])
                refactorWeight.push(weightData[weightIdx * 4 + 3])
                refactorNdx.push(ndxData[weightIdx * 4 + 0])
                refactorNdx.push(ndxData[weightIdx * 4 + 1])
                refactorNdx.push(ndxData[weightIdx * 4 + 2])
                refactorNdx.push(ndxData[weightIdx * 4 + 3])
            }
            this.attribData["weight_" + i] = new Float32Array(refactorWeight)
            this.attribData["ndx_" + i] = new Float32Array(refactorNdx)
        }

    }

    // Specific kinda
    getBindPose(){   
        this.mesh.node.needUpdate = true

        for (let i = 0; i < this.bonesNode.length; i++) {
            let tmp = mat4.create()
            mat4.transpose(tmp, this.bonesNode[i].joint.invBindMatrrix)
            mat4.invert(tmp, tmp)
            mat4.copy(this.bindPose[i], tmp)          
        }

        for (let i = 0; i < this.bindPose.length; i++) {
            mat4.invert(this.bindPoseInv[i], this.bindPose[i])
        }

    }

    update(){
        // Exemple
        for (let i = 0; i < this.bonesNode.length; i++) {
            const b = this.bonesNode[i]
            b.needUpdate = true
            mat4.copy(this.boneMatrices[i], b.getMatrix())
            mat4.multiply(this.boneMatrices[i], this.boneMatrices[i], this.bindPoseInv[i])
        }
        
    }

    renderDebug(){
        for (let i = 0; i < this.debugPoints.length; i++) {
            this.debugPoints[i].render()
        }
    }

}

export default Skin